/**
 * Returns the URL only when it is a plain http(s) link, else undefined.
 *
 * Integration link templates and tracker issue URLs are operator-supplied and
 * stored without scheme validation, so rendering them straight into an href
 * would let an org admin plant a `javascript:` URL that runs when a teammate
 * clicks it.
 */
export function safeHttpUrl(url?: string | null): string | undefined {
  if (!url) return undefined;
  try {
    const u = new URL(url, window.location.origin);
    return u.protocol === 'http:' || u.protocol === 'https:' ? u.toString() : undefined;
  } catch {
    return undefined;
  }
}
